export default __webpack_public_path__ + "static/media/DSCN8102.8bd1a733.JPG";